<template>
  <b-container>
    <div>
      <h2>{{ $t("story.title") }}</h2>
    </div>
    <!-- {{ id }} -->
    <b-table
      ref="table"
      :busy="isBusy"
      :items="loadData"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
    </b-table>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
export default {
  name: "ProcessStory",
  props: {
    id: String,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "changedColumn",
          filterKey: "changedColumn",
          label: this.$t("story.changedColumn"),
        },
        {
          key: "oldValue",
          filterKey: "oldValue",
          label: this.$t("story.oldValue"),
        },
        {
          key: "newValue",
          filterKey: "newValue",
          label: this.$t("story.newValue"),
        },
        {
          key: "date",
          filterKey: "date",
          label: this.$t("story.date"),
          thStyle: "min-width: 160px",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "userDisplayName",
          filterKey: "userDisplayName",
          label: this.$t("story.userDisplayName"),
          thStyle: "min-width: 250px",
        },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      tableFilters: {
        active: "true",
        userName: "",
        processName: "",
        dateCreate: "",
        stageName: "",
        id: "",
        stageDateUpdate: ""
      },
    };
  },
  methods: {
    loadData(ctx, callback) {
      // let idString = ;
      // console.log(idString);
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        active: ctx.filter.active,
        userName: ctx.filter.userName,
        processName: ctx.filter.processName,
        stageName: ctx.filter.stageName,
        id: `${this.id}`,
      };
      this.isBusy = true;
      this.$apiWorkflow
        .post("/processFilled/story/", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>
